import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {ROUTE_NAMES} from "../../../core/consts";
import {AccumulatorLinkParams} from "./accumulator-link-params";

export class AccumulatorLinkModel extends BaseLinkModel  {
  constructor() {
    super(ROUTE_NAMES.accumulator, new AccumulatorLinkParams());
  }
}